import { Boxes, ExternalLink } from 'lucide-react';
import type { ProjectView } from '@vwt/contracts';
import { Badge, Button } from '@vwt/ui';
import { useTranslation } from '../../lib/i18n.js';

/** Marks a project that mirrors a Vammo App (ADR-0037). */
export function VammoAppBadge() {
  const { t } = useTranslation();
  return (
    <Badge tone="info">
      <Boxes /> {t('projects.vammoApps.badge')}
    </Badge>
  );
}

/** Link to the app's page in the Vammo Apps portal. */
export function OpenInVammoApps({ project, compact = false }: { project: Pick<ProjectView, 'vammoApp'>; compact?: boolean }) {
  const { t } = useTranslation();
  if (!project.vammoApp) return null;
  return (
    <Button asChild {...(compact ? { size: 'sm' as const, variant: 'ghost' as const } : {})}>
      <a href={project.vammoApp.portalUrl} target="_blank" rel="noreferrer">
        <ExternalLink /> {t('projects.vammoApps.open')}
      </a>
    </Button>
  );
}
